import React, { Component } from 'react';
import PropTypes from 'prop-types';
//Componentes Material
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Pagination from '@material-ui/lab/Pagination';

import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Chip from '@material-ui/core/Chip';
import Avatar from '@material-ui/core/Avatar';
import Divider from '@material-ui/core/Divider';
import CircularProgress from '@material-ui/core/CircularProgress';
import Box from '@material-ui/core/Box';
import Alert from '@material-ui/lab/Alert';
import { withStyles } from '@material-ui/core/styles';
//Ícones
import PersonIcon from '@material-ui/icons/Person';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import DeleteIcon from '@material-ui/icons/Delete';
import SearchIcon from '@material-ui/icons/Search';
import SaveIcon from '@material-ui/icons/Save';
//Componentes
import Layout from './Layout';
import VitalizePaper from '../components/VitalizePaper';
import LabelSecao from '../components/LabelSecao';
//Controllers
import ClienteAvaliadorController from '../controllers/ClienteAvaliadorController';
import ClienteController from '../controllers/ClienteController';
import AvaliadorController from '../controllers/AvaliadorController';
import PermissaoController from '../controllers/PermissaoController';

//Definindo estilos
const styles = (theme) => ({
    root: {
        padding: theme.spacing(3),
        background: theme.palette.background.default,
        minHeight: '100vh'
    },
    headerSection: {
        background: theme.palette.background.paper,
        color: theme.palette.text.primary,
        padding: theme.spacing(4),
        borderRadius: theme.spacing(2),
        marginBottom: theme.spacing(3),
        boxShadow: theme.shadows[4]
    },
    headerTitle: {
        fontWeight: 'bold',
        fontSize: '2.5rem',
        marginBottom: theme.spacing(1)
    },
    headerSubtitle: {
        fontSize: '1.1rem',
        opacity: 0.9,
        color: theme.palette.text.secondary
    },
    stepCard: {
        background: theme.palette.background.paper,
        backdropFilter: 'blur(10px)',
        borderRadius: theme.spacing(2),
        boxShadow: theme.shadows[2],
        border: `1px solid ${theme.palette.divider}`,
        transition: 'all 0.3s ease',
        '&:hover': {
            transform: 'translateY(-4px)',
            boxShadow: theme.shadows[6]
        }
    },
    stepHeader: {
        background: theme.palette.background.paper,
        color: theme.palette.text.primary,
        borderRadius: `${theme.spacing(2)}px ${theme.spacing(2)}px 0 0`,
        borderBottom: `1px solid ${theme.palette.divider}`
    },
    stepAvatar: {
        background: theme.palette.primary.main,
        color: theme.palette.primary.contrastText
    },
    searchField: {
        marginBottom: theme.spacing(2),
        '& .MuiOutlinedInput-root': {
            borderRadius: theme.spacing(1),
            background: theme.palette.background.default
        }
    },
    clienteCard: {
        marginBottom: theme.spacing(1),
        cursor: 'pointer',
        borderRadius: theme.spacing(1),
        transition: 'all 0.2s ease',
        border: `1px solid ${theme.palette.divider}`,
        '&:hover': {
            backgroundColor: theme.palette.action.hover,
            transform: 'translateX(4px)',
            boxShadow: theme.shadows[2]
        }
    },
    selectedClienteCard: {
        backgroundColor: theme.palette.action.selected,
        borderColor: theme.palette.primary.main,
        '&:hover': {
            backgroundColor: theme.palette.action.selected
        }
    },
    avaliadorCard: {
        marginBottom: theme.spacing(2),
        borderRadius: theme.spacing(1),
        border: `1px solid ${theme.palette.divider}`
    },
    clienteChip: {
        margin: theme.spacing(0.5),
        borderRadius: theme.spacing(1),
        transition: 'all 0.2s ease',
        '&:hover': {
            transform: 'scale(1.05)'
        }
    },
    loadingContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: 300,
        background: theme.palette.background.paper,
        borderRadius: theme.spacing(2)
    },
    statsContainer: {
        marginBottom: theme.spacing(3)
    },
    emptyState: {
        textAlign: 'center',
        padding: theme.spacing(4),
        color: theme.palette.text.secondary,
        background: theme.palette.action.hover,
        borderRadius: theme.spacing(1),
        border: `2px dashed ${theme.palette.divider}`
    },
    actionButton: {
        borderRadius: theme.spacing(3),
        padding: theme.spacing(1.5, 4),
        fontWeight: 'bold',
        textTransform: 'none',
        fontSize: '1rem',
        boxShadow: theme.shadows[2],
        transition: 'all 0.3s ease',
        '&:hover': {
            transform: 'translateY(-2px)',
            boxShadow: theme.shadows[4]
        }
    },
    primaryButton: {
        background: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        '&:hover': {
            background: theme.palette.primary.dark
        }
    },
    secondaryButton: {
        background: theme.palette.secondary.main,
        color: theme.palette.secondary.contrastText,
        '&:hover': {
            background: theme.palette.secondary.dark
        }
    },
    removalBox: {
        marginTop: theme.spacing(2),
        padding: theme.spacing(2),
        background: theme.palette.background.paper,
        borderRadius: theme.spacing(1),
        border: `1px solid ${theme.palette.error.main}`
    },
    selectionBox: {
        marginTop: theme.spacing(2),
        padding: theme.spacing(2),
        background: theme.palette.background.paper,
        borderRadius: theme.spacing(1),
        border: `1px solid ${theme.palette.success.main}`
    }
});

/**
 * Página para gerenciar atribuições entre clientes e avaliadores
 */
class ClienteAvaliadorPage extends Component {
    constructor(props) {
        super(props);
        //Bindings
        this.handleBuscaClienteChange = this.handleBuscaClienteChange.bind(this);
        this.buscarAvaliadores = this.buscarAvaliadores.bind(this);
        this.handleSelecionarAvaliador = this.handleSelecionarAvaliador.bind(this);
        this.handleSalvarAlteracoes = this.handleSalvarAlteracoes.bind(this);
        this.handleLimparSelecao = this.handleLimparSelecao.bind(this);
        this.handleMoverParaDireita = this.handleMoverParaDireita.bind(this);
        this.handleMoverParaEsquerda = this.handleMoverParaEsquerda.bind(this);
        this.handlePaginaDisponiveisChange = this.handlePaginaDisponiveisChange.bind(this);

        //Inicializa os controllers
        this.clienteAvaliadorController = new ClienteAvaliadorController();
        this.clienteController = new ClienteController();
        this.avaliadorController = new AvaliadorController();
        this.permissaoController = new PermissaoController();

        //Estado inicial
        this.state = {
            carregando: true,
            carregandoClientes: false,

            // Avaliadores
            avaliadores: [],
            buscandoAvaliadores: false,
            avaliadorSelecionado: null,
            buscaAvaliador: '',

            // Clientes Disponíveis (Esquerda)
            clientesDisponiveis: [],
            totalClientesDisponiveis: 0,
            pageDisponiveis: 1,
            buscaCliente: '',
            checkedDisponiveis: [], // IDs selecionados na lista da esquerda

            // Clientes Atribuídos (Direita)
            clientesAtribuidos: [], // Lista carregada do avaliador
            checkedAtribuidos: [], // IDs selecionados na lista da direita

            // Controle de alterações
            novasAtribuicoes: new Set(), // IDs adicionados nesta sessão
            remocoesPendentes: new Set(), // IDs removidos nesta sessão

            salvando: false,
            erro: null,
            sucesso: null,
            temPermissao: false
        };
    }

    async componentDidMount() {
        // Verificar permissões
        const perfil = await this.permissaoController.retornarPerfil();
        const temPermissao = [1, 2, 3].includes(perfil); // SUPER_ADMIN, ADMIN, EMPRESA

        if (!temPermissao) {
            this.setState({
                carregando: false,
                temPermissao: false,
                erro: 'Você não tem permissão para acessar esta página.'
            });
            return;
        }

        this.setState({ temPermissao: true, carregando: false });
    }

    /**
     * Busca avaliadores sob demanda (Lazy Loading)
     */
    async buscarAvaliadores(termoBusca) {
        if (!termoBusca || termoBusca.length < 2) {
            this.setState({ avaliadores: [] });
            return;
        }

        this.setState({ buscandoAvaliadores: true });

        try {
            // Busca apenas os primeiros 20 que combinam com o nome
            const result = await this.avaliadorController.listar(1, 20, {
                nome: termoBusca
            });

            if (result.sucesso) {
                this.setState({
                    avaliadores: result.items || [],
                    buscandoAvaliadores: false
                });
            } else {
                this.setState({ buscandoAvaliadores: false });
            }
        } catch (error) {
            console.error('Erro ao buscar avaliadores', error);
            this.setState({ buscandoAvaliadores: false });
        }
    }

    /**
     * Filtra clientes baseado na busca
     */
    handleBuscaClienteChange(event) {
        const termo = event.target.value;
        this.setState({ buscaCliente: termo, pageDisponiveis: 1 }, () => {
            this._carregarClientesDisponiveis();
        });
    }



    handlePaginaDisponiveisChange(event, newPage) {
        this.setState({ pageDisponiveis: newPage }, () => {
            this._carregarClientesDisponiveis();
        });
    }

    /**
     * Seleciona um avaliador e carrega seus dados
     */
    handleSelecionarAvaliador(avaliador) {
        if (!avaliador) {
            this.setState({
                avaliadorSelecionado: null,
                clientesAtribuidos: [],
                clientesDisponiveis: [],
                checkedAtribuidos: [],
                checkedDisponiveis: [],
                novasAtribuicoes: new Set(),
                remocoesPendentes: new Set()
            });
            return;
        }

        this.setState({
            avaliadorSelecionado: avaliador,
            carregandoClientes: true,
            checkedAtribuidos: [],
            checkedDisponiveis: [],
            novasAtribuicoes: new Set(),
            remocoesPendentes: new Set(),
            pageDisponiveis: 1,
            buscaCliente: ''
        }, async () => {
            await Promise.all([
                this._carregarClientesAtribuidos(avaliador.id),
                this._carregarClientesDisponiveis()
            ]);
            this.setState({ carregandoClientes: false });
        });
    }

    async _carregarClientesAtribuidos(idAvaliador) {
        try {
            const result = await this.clienteAvaliadorController.listarClientesDoAvaliador(idAvaliador);
            const clientesAtribuidos = result.sucesso ? (result.items || []) : [];
            this.setState({ clientesAtribuidos });
        } catch (error) {
            console.error('Erro ao carregar clientes atribuídos', error);
        }
    }

    async _carregarClientesDisponiveis() {
        const { pageDisponiveis, buscaCliente } = this.state;

        try {
            // Usa pageSize 50 para ter uma lista razoável
            // listarDisponiveis retorna apenas clientes SEM nenhuma atribuição
            const result = await this.clienteController.listarDisponiveis(pageDisponiveis, 50, {
                nome: buscaCliente
            });

            if (result.sucesso) {
                this.setState({
                    clientesDisponiveis: result.items || [],
                    totalClientesDisponiveis: result.count || 0
                });
            }
        } catch (error) {
            console.error('Erro ao buscar clientes disponíveis', error);
        }
    }

    handleMoverParaDireita() {
        const { checkedDisponiveis, clientesDisponiveis, clientesAtribuidos, novasAtribuicoes, remocoesPendentes } = this.state;

        // Encontra os objetos completos dos clientes selecionados
        const novosClientes = clientesDisponiveis.filter(c => checkedDisponiveis.includes(c.id));

        const novosAtribuidos = [...clientesAtribuidos];
        const novasAtribuicoesSet = new Set(novasAtribuicoes);
        const remocoesPendentesSet = new Set(remocoesPendentes);

        novosClientes.forEach(cliente => {
            // Evita duplicatas visuais
            if (!novosAtribuidos.find(c => c.id === cliente.id)) {
                novosAtribuidos.push(cliente);

                // Logica de Tracking
                if (remocoesPendentesSet.has(cliente.id)) {
                    // Se estava marcado para remover, apenas desmarca a remoção (neutro)
                    remocoesPendentesSet.delete(cliente.id);
                } else {
                    // Se é novo mesmo, marca como nova atribuição
                    novasAtribuicoesSet.add(cliente.id);
                }
            }
        });

        this.setState({
            clientesAtribuidos: novosAtribuidos,
            checkedDisponiveis: [], // Limpa seleção da esquerda
            novasAtribuicoes: novasAtribuicoesSet,
            remocoesPendentes: remocoesPendentesSet
        });
    }

    handleMoverParaEsquerda() {
        const { checkedAtribuidos, clientesAtribuidos, novasAtribuicoes, remocoesPendentes } = this.state;

        const novosAtribuidos = clientesAtribuidos.filter(c => !checkedAtribuidos.includes(c.id));

        const novasAtribuicoesSet = new Set(novasAtribuicoes);
        const remocoesPendentesSet = new Set(remocoesPendentes);

        checkedAtribuidos.forEach(id => {
            if (novasAtribuicoesSet.has(id)) {
                // Se era uma adição nova (não salva), apenas remove da lista de adições
                novasAtribuicoesSet.delete(id);
            } else {
                // Se já existia no banco, marca para remoção
                remocoesPendentesSet.add(id);
            }
        });

        this.setState({
            clientesAtribuidos: novosAtribuidos,
            checkedAtribuidos: [], // Limpa seleção da direita
            novasAtribuicoes: novasAtribuicoesSet,
            remocoesPendentes: remocoesPendentesSet
        });
    }

    handleLimparSelecao() {
        // Reverte alterações locais
        const { avaliadorSelecionado } = this.state;
        if (avaliadorSelecionado) {
            this.handleSelecionarAvaliador(avaliadorSelecionado);
        }
    }

    async handleSalvarAlteracoes() {
        const { avaliadorSelecionado, novasAtribuicoes, remocoesPendentes } = this.state;

        if (!avaliadorSelecionado) return;
        if (novasAtribuicoes.size === 0 && remocoesPendentes.size === 0) return;

        this.setState({ salvando: true, erro: null, sucesso: null });

        try {
            const clientesParaAdicionar = Array.from(novasAtribuicoes);
            const clientesParaRemover = Array.from(remocoesPendentes);

            const result = await this.clienteAvaliadorController.atribuirMultiplos(
                avaliadorSelecionado.id,
                clientesParaAdicionar,
                clientesParaRemover
            );

            if (result.sucesso) {
                this.setState({
                    sucesso: 'Alterações salvas com sucesso!',
                    salvando: false,
                    novasAtribuicoes: new Set(),
                    remocoesPendentes: new Set()
                });
                // Recarrega para garantir sincronia
                this.handleSelecionarAvaliador(avaliadorSelecionado);
            } else {
                const msg = result.erros && result.erros.length > 0 ? result.erros[0].mensagem : 'Erro desconhecido';
                this.setState({
                    erro: 'Erro ao salvar: ' + msg,
                    salvando: false
                });
            }
        } catch (error) {
            this.setState({
                erro: 'Erro na requisição: ' + error.message,
                salvando: false
            });
        }
    }

    handleToggleCheckDisponivel(idCliente) {
        const { checkedDisponiveis } = this.state;
        const index = checkedDisponiveis.indexOf(idCliente);
        const newChecked = [...checkedDisponiveis];

        if (index === -1) {
            newChecked.push(idCliente);
        } else {
            newChecked.splice(index, 1);
        }

        this.setState({ checkedDisponiveis: newChecked });
    }

    handleToggleCheckAtribuido(idCliente) {
        const { checkedAtribuidos } = this.state;
        const index = checkedAtribuidos.indexOf(idCliente);
        const newChecked = [...checkedAtribuidos];

        if (index === -1) {
            newChecked.push(idCliente);
        } else {
            newChecked.splice(index, 1);
        }

        this.setState({ checkedAtribuidos: newChecked });
    }

    renderBotoesTransferencia() {
        const { checkedDisponiveis, checkedAtribuidos } = this.state;

        return (
            <Box display="flex" flexDirection="column" gap={2}>
                <Button
                    variant="contained"
                    color="primary"
                    disabled={checkedDisponiveis.length === 0}
                    onClick={this.handleMoverParaDireita}
                >
                    &gt; Adicionar
                </Button>
                <Button
                    variant="contained"
                    color="secondary"
                    disabled={checkedAtribuidos.length === 0}
                    onClick={this.handleMoverParaEsquerda}
                >
                    &lt; Remover
                </Button>
            </Box>
        );
    }

    /**
     * Renderiza a seleção de avaliador
     */
    renderSelecaoAvaliador() {
        const { avaliadores, avaliadorSelecionado, buscandoAvaliadores } = this.state;

        return (
            <VitalizePaper>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <LabelSecao label="1. Seleção de Avaliador" />
                    </Grid>
                    <Grid item xs={12}>
                        <Autocomplete
                            options={avaliadores}
                            getOptionLabel={(option) => option.nome}
                            value={avaliadorSelecionado}
                            loading={buscandoAvaliadores}
                            filterOptions={(x) => x} // Desativa filtro local, já vem filtrado da API
                            onInputChange={(event, newInputValue) => {
                                if (this.searchTimeout) clearTimeout(this.searchTimeout);
                                this.searchTimeout = setTimeout(() => {
                                    this.buscarAvaliadores(newInputValue);
                                }, 500);
                            }}
                            onChange={(event, newValue) => {
                                this.handleSelecionarAvaliador(newValue);
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Buscar avaliador"
                                    variant="outlined"
                                    fullWidth
                                    placeholder="Comece a digitar o nome do avaliador..."
                                    InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                            <React.Fragment>
                                                {buscandoAvaliadores ? <CircularProgress color="inherit" size={20} /> : null}
                                                {params.InputProps.endAdornment}
                                            </React.Fragment>
                                        ),
                                    }}
                                />
                            )}
                            renderOption={(option) => (
                                <Box style={{ padding: 8 }}>
                                    <Typography variant="body1" style={{ fontWeight: 500 }}>{option.nome}</Typography>
                                    <Typography variant="body2" color="textSecondary">{option.email}</Typography>
                                </Box>
                            )}
                            noOptionsText="Digite pelo menos 2 letras para buscar"
                            clearText="Limpar"
                            openText="Abrir"
                            closeText="Fechar"
                        />
                    </Grid>
                    {avaliadorSelecionado && (
                        <Grid item xs={12}>
                            <Box style={{ padding: 16, backgroundColor: '#f5f5f5', borderRadius: 4 }}>
                                <Typography variant="subtitle2" gutterBottom>
                                    Avaliador Selecionado:
                                </Typography>
                                <Typography variant="body1">
                                    <strong>{avaliadorSelecionado.nome}</strong>
                                </Typography>
                                <Typography variant="body2" color="textSecondary">
                                    {avaliadorSelecionado.email}
                                </Typography>
                            </Box>
                        </Grid>
                    )}
                </Grid>
            </VitalizePaper>
        );
    }

    /**
     * Renderiza os clientes já atribuídos ao avaliador selecionado
     */
    renderClientesAtribuidos() {
        const { classes } = this.props;
        const { clientesAtribuidos, checkedAtribuidos, remocoesPendentes, novasAtribuicoes } = this.state;

        return (
            <VitalizePaper style={{ height: '100%' }}>
                <Typography variant="h6" gutterBottom>
                    Formandos Atribuídos ({clientesAtribuidos.length})
                </Typography>
                <Divider style={{ marginBottom: 16 }} />

                <Box style={{ height: 400, overflowY: 'auto', border: '1px solid #e0e0e0', borderRadius: 4 }}>
                    <List dense>
                        {clientesAtribuidos.map(cliente => {
                            const isNovo = novasAtribuicoes.has(cliente.id);
                            const isRemovido = remocoesPendentes.has(cliente.id);

                            return (
                                <ListItem
                                    key={cliente.id}
                                    button
                                    onClick={() => this.handleToggleCheckAtribuido(cliente.id)}
                                    style={{
                                        backgroundColor: isRemovido ? '#ffebee' : (isNovo ? '#e8f5e8' : 'transparent'),
                                        textDecoration: isRemovido ? 'line-through' : 'none'
                                    }}
                                >
                                    <ListItemIcon>
                                        <Checkbox
                                            edge="start"
                                            checked={checkedAtribuidos.includes(cliente.id)}
                                            tabIndex={-1}
                                            disableRipple
                                        />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary={cliente.nome}
                                        secondary={cliente.email}
                                        style={{ color: isRemovido ? '#d32f2f' : 'inherit' }}
                                    />
                                    {isNovo && <Chip size="small" label="Novo" color="primary" variant="outlined" />}
                                    {isRemovido && <Chip size="small" label="Remover" color="secondary" variant="outlined" />}
                                </ListItem>
                            );
                        })}
                        {clientesAtribuidos.length === 0 && (
                            <ListItem>
                                <ListItemText primary="Nenhum formando atribuído" style={{ textAlign: 'center', color: '#999' }} />
                            </ListItem>
                        )}
                    </List>
                </Box>
            </VitalizePaper>
        );
    }

    /**
     * Renderiza os clientes disponíveis para atribuição
     */
    renderClientesDisponiveis() {
        const { classes } = this.props;
        const { clientesDisponiveis, checkedDisponiveis, buscaCliente, pageDisponiveis, totalClientesDisponiveis, carregandoClientes } = this.state;

        // Calcular total de páginas (assumindo pageSize = 50)
        const totalPages = Math.ceil(totalClientesDisponiveis / 50);

        return (
            <VitalizePaper style={{ height: '100%' }}>
                <Typography variant="h6" gutterBottom>
                    Formandos Disponíveis
                </Typography>
                <Divider style={{ marginBottom: 16 }} />

                <TextField
                    fullWidth
                    label="Buscar formando"
                    placeholder="Nome, email..."
                    value={buscaCliente}
                    onChange={this.handleBuscaClienteChange}
                    variant="outlined"
                    size="small"
                    style={{ marginBottom: 16 }}
                    InputProps={{
                        startAdornment: <SearchIcon color="action" />
                    }}
                />

                <Box style={{ height: 350, overflowY: 'auto', border: '1px solid #e0e0e0', borderRadius: 4, position: 'relative' }}>
                    {carregandoClientes && (
                        <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(255,255,255,0.7)', zIndex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <CircularProgress />
                        </div>
                    )}
                    <List dense>
                        {clientesDisponiveis.map(cliente => (
                            <ListItem
                                key={cliente.id}
                                button
                                onClick={() => this.handleToggleCheckDisponivel(cliente.id)}
                            >
                                <ListItemIcon>
                                    <Checkbox
                                        edge="start"
                                        checked={checkedDisponiveis.includes(cliente.id)}
                                        tabIndex={-1}
                                        disableRipple
                                    />
                                </ListItemIcon>
                                <ListItemText
                                    primary={cliente.nome}
                                    secondary={cliente.email}
                                />
                            </ListItem>
                        ))}
                        {clientesDisponiveis.length === 0 && !carregandoClientes && (
                            <ListItem>
                                <ListItemText primary="Nenhum formando encontrado" style={{ textAlign: 'center', color: '#999' }} />
                            </ListItem>
                        )}
                    </List>
                </Box>
                <Box display="flex" justifyContent="center" marginTop={2}>
                    <Pagination
                        count={totalPages}
                        page={pageDisponiveis}
                        onChange={this.handlePaginaDisponiveisChange}
                        color="primary"
                        size="small"
                    />
                </Box>
            </VitalizePaper>
        );
    }

    /**
     * Renderiza o painel de ações
     */
    renderPainelAcoes() {
        const { novasAtribuicoes, remocoesPendentes, salvando } = this.state;
        const temAlteracoes = novasAtribuicoes.size > 0 || remocoesPendentes.size > 0;

        if (!temAlteracoes) return null;

        return (
            <VitalizePaper style={{ marginTop: 16, backgroundColor: '#f0f7ff', border: '1px solid #cce5ff' }}>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Box>
                        <Typography variant="subtitle1" color="primary" style={{ fontWeight: 'bold' }}>
                            Alterações Pendentes:
                        </Typography>
                        <Typography variant="body2">
                            {novasAtribuicoes.size} novos formandos a adicionar, {remocoesPendentes.size} a remover.
                        </Typography>
                    </Box>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={this.handleSalvarAlteracoes}
                        disabled={salvando}
                        startIcon={salvando ? <CircularProgress size={20} color="inherit" /> : <SaveIcon />}
                    >
                        {salvando ? 'Salvando...' : 'Salvar Alterações'}
                    </Button>
                </Box>
            </VitalizePaper>
        );
    }

    render() {
        const { classes, onLogout, usuario, empresa, permissoes } = this.props;
        const { carregando, erro, sucesso, temPermissao, avaliadorSelecionado } = this.state;

        if (!temPermissao) {
            return (
                <Layout onLogout={onLogout} usuario={usuario} empresa={empresa} permissoes={permissoes}>
                    <Box className={classes.root}>
                        <Alert severity="error">{erro || 'Acesso negado.'}</Alert>
                    </Box>
                </Layout>
            );
        }

        return (
            <Layout
                onLogout={onLogout}
                usuario={usuario}
                empresa={empresa}
                permissoes={permissoes}
                carregando={carregando}
            >
                <Box className={classes.root}>
                    <Box className={classes.headerSection}>
                        <Typography variant="h3" className={classes.headerTitle}>
                            🔗 Atribuição de Formandos
                        </Typography>
                        <Typography variant="h6" className={classes.headerSubtitle}>
                            Gerencie as atribuições entre formandos e avaliadores (Lote)
                        </Typography>
                    </Box>

                    {erro && <Alert severity="error" style={{ marginBottom: 16 }}>{erro}</Alert>}
                    {sucesso && <Alert severity="success" style={{ marginBottom: 16 }}>{sucesso}</Alert>}

                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            {this.renderSelecaoAvaliador()}
                        </Grid>

                        {avaliadorSelecionado && (
                            <>
                                <Grid item xs={12} md={5}>
                                    {this.renderClientesDisponiveis()}
                                </Grid>
                                <Grid item xs={12} md={2} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    {this.renderBotoesTransferencia()}
                                </Grid>
                                <Grid item xs={12} md={5}>
                                    {this.renderClientesAtribuidos()}
                                </Grid>
                                <Grid item xs={12}>
                                    {this.renderPainelAcoes()}
                                </Grid>
                            </>
                        )}

                        {!avaliadorSelecionado && !carregando && (
                            <Grid item xs={12}>
                                <Box display="flex" justifyContent="center" p={4}>
                                    <Typography variant="h6" color="textSecondary">
                                        Selecione um avaliador acima para começar.
                                    </Typography>
                                </Box>
                            </Grid>
                        )}
                    </Grid>
                </Box>
            </Layout>
        );
    }
}

export default withStyles(styles)(ClienteAvaliadorPage);